import { ActiveButton } from "./ActiveButton";
import { ConnectButton } from "./ConnectButton";
import { PendingButton } from "./PendingButton";
import { RespondButtons } from "./RespondButtons";

export const ConnectionCTA = ({ member }: { member: any }) => {
  const memberConnection = member?.connection_to_current_community_member;

  if (
    !memberConnection ||
    memberConnection.status === "detached" ||
    memberConnection.status === "withdrawn"
  ) {
    return <ConnectButton member={member} />;
  }

  if (
    memberConnection.status === "ignored" &&
    memberConnection.initiator.id === member.id
  ) {
    return <ConnectButton member={member} />;
  }

  if (memberConnection?.status === "active") {
    return <ActiveButton />;
  }

  if (memberConnection?.status === "pending") {
    // Connection was initiated by the other person
    if (memberConnection.initiator.id === member.id) {
      return <RespondButtons member={member} connection={memberConnection} />;
    }

    return <PendingButton />;
  }

  return null;
};
